import { Suspense } from "react";
import pageLoader from "../assets/images/page-loader.svg";
import { Box } from "@mui/material";
const Loadable = (Component: any) => {
  return (
    <Suspense
      fallback={
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          height="65vh"
         >
          <img src={pageLoader} width="90px"  alt="page loader"/>
        </Box>
      }
    >
      <Component />
    </Suspense>
  );
};

export default Loadable;
